import React from 'react'
import { Trans } from 'react-i18next'
import { MenuSettingItem } from 'views/InhouseGame/components/styled'

const VolumeControls: React.FC<{
  onChangeSetting: (enable: boolean) => void
  value: boolean
}> = ({ value, onChangeSetting }) => {
  return (
    <MenuSettingItem icon="VolumeIcon" active={value} onClick={() => onChangeSetting(!value)}>
      <Trans>Volume</Trans>
    </MenuSettingItem>
  )
}

export default VolumeControls
